/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
var $productGallerySlider = null;
var $cells = null;
var variantImages = [];
var productImages = [];
var cartToken = '';
var isInViewport = function (elem) {
    var bounding = elem.getBoundingClientRect();
    return (bounding.top >= 0 && bounding.left >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth || document.documentElement.clientWidth));
};

addEventListener("variant:change", function (event) {
    // console.log($('.price-list sale-price.h4').text().split(' '))
    // console.log($('.product-info__block-item .price-list sale-price .price-value').html())
    if ($('.product-info__block-item .price-list sale-price .price-value').html()) {
        $('.product-info__block-item .price-list sale-price .price-value').eq(0).remove()
        $('.product-info__block-item .price-list sale-price .price-value').html($('.product-info__block-item .price-list sale-price .price-value').html().replace(',', ' '))
    }

    $('.product-info__block-item .price-list compare-at-price > .price-value').remove()
    $('.product-info__block-item .price-list compare-at-price > .currency').remove()

    // Omnibus price: hide if variant has no omnibus price, show and update if it does
    var variant = event.detail.variant;
    var omnibusDataEl = document.querySelector('#variant-omnibus-data [data-variant-id="' + variant.id + '"]');
    var omnibusPrice = omnibusDataEl ? omnibusDataEl.getAttribute('data-omnibus') : '';
    var omnibusFormatted = omnibusDataEl ? omnibusDataEl.getAttribute('data-omnibus-formatted') : '';
    var omnibusPriceContainer = document.querySelectorAll('.omnibus-price');

    if (omnibusPriceContainer.length) {
        var isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (isOnSale && omnibusPrice && omnibusPrice !== '' && parseInt(omnibusPrice) > 0) {
            omnibusPriceContainer.forEach((el) => el.style.display = '');
            omnibusPriceContainer.forEach((el) => {
                var priceSpan = el.querySelector('.h6');
                if (priceSpan) {
                    priceSpan.textContent = omnibusFormatted;
                }
            });
        } else {
            omnibusPriceContainer.forEach((el) => el.style.display = 'none');
        }
    }
});



// newsletter

document.addEventListener('DOMContentLoaded', function () {
    const params = new URLSearchParams(window.location.search);

    const isNewsletterPage = window.location.pathname === '/pages/newsletter';
    const isNewsletterSuccess = params.get('customer_posted') === 'true';

    const successBlock = document.querySelector(
        '#shopify-section-template--28726344712534__image_with_text_jVdkDt'
    );

    const defaultNewsletterBlock = document.querySelector('.newsletter.cnt');

    if (!isNewsletterPage) return;

    if (isNewsletterSuccess) {
        if (successBlock) {
            successBlock.style.display = 'block';
        }

        if (defaultNewsletterBlock) {
            defaultNewsletterBlock.style.display = 'none';
        }

        return;
    }

    if (successBlock) {
        successBlock.style.display = 'none';
    }
});

// newsletter

emailRegex = /^(([^<>()\[\]\\.,;:\s@"+]+(\.[^<>()\[\]\\.,;:\s@"+]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

[].forEach.call(document.querySelectorAll('.js-section-link'), function (el) {
    el.addEventListener('click', function () {
        var scrollTarget = this.getAttribute('data-sectionid'),
            clickAfterScroll = this.getAttribute('data-clickafter'),
            scrollTargetElement = document.getElementById(scrollTarget);
        if (scrollTarget) {
            if (clickAfterScroll === 'true') {
                scrollTargetElement.querySelectorAll('.Collapsible__Button')[0].click();
            }
            scrollTargetElement.scrollIntoView({ behavior: "smooth" });
        }
    }, false);
});

function getUrlParameter(name) {
    name = name
        .replace(/[\[]/, '\\[')
        .replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null
        ? ''
        : decodeURIComponent(results[1].replace(/\+/g, ' '));
};


function variantImagesManage(selectedVariantID) {
    var isThbSelected = null;
    Object
        .keys(product_variants)
        .map(function (item) {
            var index = $('#Image' + product_variants[item]).index();
            if (item == selectedVariantID) {
                $('.Product__SlideshowNavImage[data-image-id="' + product_variants[item] + '"]').addClass('is-visible').click();
                isThbSelected = 1;
                $('#Image' + product_variants[item]).show();
                $('.flickity-page-dots .dot').eq(index).show();
            } else {
                $('[data-image-id="' + product_variants[item] + '"]').addClass('hidden').removeClass('is-visible');
                $('#Image' + product_variants[item]).hide();
                $('.flickity-page-dots .dot').eq(index).hide();
                if (!isThbSelected) {
                    if ($('.Product__SlideshowNavImage.is-visible').length) {
                        $('.Product__SlideshowNavImage.is-visible').eq(0).click();
                    } else {
                        $('.Product__SlideshowNavImage').eq(0).click();
                    }
                }
            }
        });
    // $productGallerySlider.flickity('resize');
    // $productGallerySlider.flickity('reposition');
    // $productGallerySlider.flickity('reloadCells');
};
var _wr = function (type) {
    var orig = history[type];
    return function () {
        var rv = orig.apply(this, arguments);
        var e = new Event(type);
        e.arguments = arguments;
        window.dispatchEvent(e);
        return rv;
    };
};

history.pushState = _wr('pushState');
history.replaceState = _wr('replaceState');
function checkInstafeed() {
    $('.Instafeed__Cell')
        .each(function () {
            if (isInViewport(this)) {
                $(this).addClass('in-view');
            } else {
                $(this).removeClass('in-view');
            }
        });
}
function findGeneralImages() {
    // var variantImages = 
    var allImages = [];
    $('.Product__SlideshowNavImage').each(function () {
        allImages.push($(this).data('imageId'));
    });
    return $(allImages).not(variantImages).get();
};
function customrInputsChange(el) {
    // console.log(el);
    // el.preventDefault();
    // var $this = $(el.target);
    // console.log($this[0].checked);
    // if ($this[0].checked) {
    //     $this[0].checked = false;
    // } else {
    //     $this[0].checked = true;
    // }
    // console.log($this[0].checked);
};

function adjustGallery(selectedVariantID) {
    var hasActive = false;
    $productGallerySlider.flickity('remove', $cells);
    $cells.map(function (item) {
        $('.Product__SlideshowNavImage[data-image-id="' + $cells[item].id.replace('Image', '') + '"]').addClass('hidden').removeClass('is-visible is-selected');
        if ($cells[item].id == 'Image' + product_variants[selectedVariantID]) {
            $productGallerySlider.flickity('insert', $cells[item]);
            if (!hasActive) {
                $('.Product__SlideshowNavImage[data-image-id="' + $cells[item].id.replace('Image', '') + '"]').removeClass('hidden').addClass('is-selected').click();
            }
            hasActive = true;
        }
        findGeneralImages().map(function (index) {
            if ($cells[item].id == 'Image' + index) {
                if (hasActive) {
                    $('.Product__SlideshowNavImage[data-image-id="' + $cells[item].id.replace('Image', '') + '"]').removeClass('is-selected hidden');
                } else {
                    $('.Product__SlideshowNavImage[data-image-id="' + $cells[item].id.replace('Image', '') + '"]').removeClass('hidden').addClass('is-selected').click();
                }
                $productGallerySlider.flickity('insert', $cells[item]);
            }
        });
    });
    $productGallerySlider.flickity('resize');
    $productGallerySlider.flickity('reposition');
    $productGallerySlider.flickity('reloadCells');
};
window
    .addEventListener('scroll', function (event) {
        checkInstafeed();
    }, false);

document.addEventListener("DOMContentLoaded", function () {
    $('[data-action="toggle-search"]').on('mouseover', function () {
        $(".Header__MainNav .is-expanded")
            .removeClass("is-expanded")
            .find(".MegaMenu")
            .attr("aria-hidden", "true");
    });
    $
        .ajax({
            url: "/cart.js",
            dataType: "json",
        })
        .done(function (data) {
            console.log(data)
            if (data.token) {
                cartToken = data.token;
                jQuery("#sideCartForm").attr(
                    "action",
                    "/apps/checkout/" + cartToken
                );
            }
        });
    $(document).on("click", "#sideCartForm .button.w-full", function () {
        jQuery("#sideCartForm").attr("action", "/apps/checkout/" + cartToken);
    });
    // $(document).on("click", ".CartItem__Remove", removeFromCartCallback);
    $(document).on('mouseover', '.Instafeed__Cell', checkInstafeed);
    // $(document).on('click', '.customr-control', customrInputsChange);
    if (document.getElementById('ProductGallery')) {
        console.log('image gallery')
        var jsonData = JSON.parse(
            document.querySelector("[data-product-json]").innerHTML
        );

        if ($(".Product__Gallery .Carousel__Cell").length > 1) {
            $productGallerySlider = $(".Product__Gallery .Carousel").flickity();
            $cells = $productGallerySlider.find(".Carousel__Cell");
            //   variantImagesManage(jsonData["selected_variant_id"]);
            //   adjustGallery(jsonData["selected_variant_id"]);
            $(".Product__SlideshowNavImage").on("click", function () {
                var imageId = $(this).data("imageId");
                $productGallerySlider.flickity(
                    "select",
                    $("#Image" + imageId).index(),
                    false,
                    true
                );
            });
        }
        if (Object.keys(product_variants).length > 1) {
            Object.keys(product_variants).map(function (item) {
                var index = $('#Image' + product_variants[item]).index();
                $('[data-image-id="' + product_variants[item] + '"]').addClass('hidden');
                // $('#Image' + product_variants[item]).hide();
                $('.flickity-page-dots .dot').eq(index).hide();
                variantImages.push(parseInt(product_variants[item]));
            });

            var currentVariantImage = product_variants[getUrlParameter("variant")] || product_variants[jsonData["selected_variant_id"]];

            $('.Product__SlideshowNavScroller .is-selected').removeClass('is-selected');
            $('[data-image-id="' + currentVariantImage + '"]')
                .removeClass("hidden")
                .addClass("is-selected");
            window.addEventListener('replaceState', function (e) {
                adjustGallery(getUrlParameter('variant'));
            });
        }
    };
    $(document).on('click', '.js-show-more', function (e) {
        e.preventDefault();
        $this = $(this);
        if ($this.data('active') === false) {
            $this.data("active", true);
            $this.text($this.data("less"));
        } else {
            $this.data("active", false);
            $this.text($this.data("more"));
        }
        $this.siblings(".to-show").toggleClass("hidden");
    });

    $(document).on('click', '.promo-code', function (e) {
        e.preventDefault();
        var $this = $(this);
        var defaultText = $this.find('span').text().trim();
        navigator.clipboard.writeText($this.text().trim());
        $this.find('span').text('Skopiowano');
        setTimeout(function () {
            $this.find('span').text(defaultText);
        }, 3000);
    });

    function setStickyBarOffset() {
        var barHeight = $('#section-announcement').height();

        $('html').css('margin-top', barHeight);
    }

    $('.newsletter-form .button').on('click', function (e) {
        var $this = $(this),
            formId = $this.closest('form').attr('id'),
            from = $this.closest('form').data('from')
        e.preventDefault();
        e.stopPropagation();
        checkAgreements(formId, from);
    });

    setStickyBarOffset();

    $(window).on('resize', function () {
        setStickyBarOffset();
    });
});

if (
    navigator.userAgent.indexOf("Safari") != -1 &&
    navigator.userAgent.indexOf("Chrome") == -1
) {
    $(window).bind("pageshow", function (event) {
        var pageTransition = document.querySelector(".PageTransition");
        if (window.theme.showPageTransition && pageTransition) {
            new TimelineLite().fromTo(
                pageTransition,
                0.25,
                { autoAlpha: 1, ease: Linear.easeNone },
                { autoAlpha: 0, ease: Linear.easeNone }
            );
        }
    });
}

var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
    }
}

function clearURL() {
    var url = document.location.href;
    window.history.pushState({}, "", url.split("?")[0]);
}

function checkAgreements(formId, from) {
    var $form = $('#' + formId);
    var $errorWrapper = $form.find('.newsletter-form-error-wrapper');
    var $errorMessage = $form.find('.newsletter-form-error');
    var errorText = $form.data('agreement-error') || 'Please accept the required agreements.';

    if ($form.find('.required:checked').length !== $form.find('.required').length) {
        $form.find('.required').not(':checked').parent().addClass('text-error');
        if ($errorWrapper.length && $errorMessage.length) {
            $errorMessage.text(errorText);
            $errorWrapper.removeClass('hidden');
        }
    } else {
        $form.find('.required').parent().removeClass('text-error');
        if ($errorWrapper.length) {
            $errorWrapper.addClass('hidden');
        }
        SR.event.sendFormData('contact', {
            // form data
            "email": $('#' + formId + ' [name="contact[email]"]').val(),
            "tags": "newsletter",
            "contact[marketing]": 'enabled',
            "marketingAgreement": 'confirmation',
            "newsletterSubscribeFrom": from
        })
        // setTimeout(function () {
        $('#' + formId).submit();
        // }, 300)
    }
}

function validate(fieldSelector, regexp) {
    if ($(fieldSelector).match(regexp)) {
        alert('valid')
    } else {
        alert('notvalid')
    }
}